/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import getPostsByType from '../../../../api/graphql/queries/getPostsByType';

import Autocomplete from '../../../Form/Autocomplete';


const TestAB = ({
  handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname,
}) => {
  let _isMounted = false;
  const initialState = {
    type: 'TestAB',
    components: [
      {
        key: '',
      },
      {
        key: '',
      },
    ],
  };


  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(true);
  const [allPosts, setAllPosts] = useState([]);
  const [compUpdated, setCompUpdated] = useState([{
    key: '',
  },
  {
    key: '',
  }]);

  const getPosts = async () => {
    try {
      const res = await getPostsByType('component');
      if (res && _isMounted) {
        const { posts } = res;
        const routePosts = posts.map(post => post.slugName);
        setAllPosts(routePosts);
        setIsLoading(false);
      }
    } catch {
      err => console.log(err, ' => getPostsByCategory');
    }
  };

  useEffect(() => {
    _isMounted = true;
    getPosts();
    return () => {
      _isMounted = false;
    };
  }, []);

  const storeText = (currField, val) => {
    const { component } = components[index];


    if (currField === 'postSlugName1') {
      compUpdated[0] = { key: val.toLowerCase() };
    } else {
      compUpdated[1] = { key: val.toLowerCase() };
    }
    setCompUpdated(compUpdated);

    const comp = {
      ...component,
      components: compUpdated
      ,
    };


    setState(comp);


    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };


  useEffect(() => {
    if (_isMounted) {
      const componentIndex = components.findIndex(obj => obj.id === id);
      const { component } = components[componentIndex];
      if (reusableComponent) {
        setState(reusableComponent);
        if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
      } else {
        setIndex(componentIndex);
        if (component) {
          setCompUpdated(component.components);
          setState(component);
        } else {
          const componentObj = {
            id,
            component: state,
          };

          handlerSetComponents(componentObj, componentIndex);
        }
      }
    }
  }, [components]);


  return (
    <>

      {!isLoading && (
        <div className="w-full bg-greyFilter pl-12 rounded justify-around flex flex-row">
          <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black w-full" htmlFor="slugA">
            <Autocomplete title="Post Slugname 1" name="postSlugName1" message="The post slug does not exist" suggestions={allPosts} storeText={storeText} action="create" value={compUpdated[0].key.toLowerCase()} />
          </label>
          <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black w-full px-2" htmlFor="slugB">
            <Autocomplete title="Post Slugname 2" name="postSlugName2" message="The post slug does not exist" suggestions={allPosts} storeText={storeText} action="create" value={compUpdated[1].key.toLowerCase()} />
          </label>
        </div>
      )}

    </>
  );
};

TestAB.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
};
TestAB.defaultProps = {
  reusableComponent: null,
};

export default TestAB;
